import { useSxpContext } from '../core/sxp-context/sxp-context';
import { useSyncContext } from '../core/sync-context/sync-context';
import { useTrialBanner } from './useTrialBanner';

const GLOBAL_NAV_HEIGHT = 41;
export const PREDICT_NAV_HEIGHT = 40;
export const PREDICT_SECONDARY_NAV_HEIGHT = 41;
const TRIAL_BAR_HEIGHT = 48;
const SYNC_BANNER_HEIGHT = 48;

export const useNavHeight = () => {
  const { displayGlobalNav } = useSxpContext();
  const { hasTrialBanner } = useTrialBanner();
  const { syncResultType } = useSyncContext();

  const navHeight =
    (displayGlobalNav ? GLOBAL_NAV_HEIGHT : PREDICT_NAV_HEIGHT) +
    PREDICT_SECONDARY_NAV_HEIGHT +
    (hasTrialBanner ? TRIAL_BAR_HEIGHT : 0) +
    (syncResultType ? SYNC_BANNER_HEIGHT : 0);

  return { navHeight };
};
